export const resolveProfilePhotoUrl = (url: string | null) => {
  if (!url || !url.startsWith('/')) {
    return url ?? undefined;
  }

  return `${(process.env.API_URL ?? '').replace(/\/$/, '')}${url}`;
};
